import { render, staticRenderFns } from "./LawDamagesClaimTypeList.vue?vue&type=template&id=084dc36e&"
import script from "./LawDamagesClaimTypeList.vue?vue&type=script&lang=js&"
export * from "./LawDamagesClaimTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LawDamagesClaimTypeList.vue?vue&type=style&index=0&id=084dc36e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports